import { useQuery } from 'react-query';
import { getPatientNotes } from '../api/getPatientNotes';

const usePatientNotes = (patientID) => {
  const result = useQuery('patient_note_' + patientID, () => getPatientNotes(patientID), {
    refetchOnWindowFocus: false,
  });
  return result;
};

export default usePatientNotes;
